import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import styles from './MultivariateAnalysis.module.css';
import GlobalFilter from './Filter/GlobalFilters';
import MultivariateAnalysisChart from './ParallelCoordinates';
import "../style.css"
import { useMultivarientVehicleData } from './context';

function MultivariateAnalysisTab() {
  const { GlobalData, setGlobalData } = useMultivarientVehicleData()

  const chartRefOne = useRef()
  const autoScrollToChartDiv = () => {
    setTimeout(() => {
      const element = chartRefOne.current;
      const rect = element.getBoundingClientRect();
      const offset = 100;

      chartRefOne.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 150);
  }
  return (
    <div className={` ${styles.sections_outline}`}>
      <div>
        <GlobalFilter autoScrollToChartDiv={autoScrollToChartDiv} />
      </div>

      <div className="col-12">
        {(GlobalData?.VIN_NUM?.length || GlobalData?.REG_NUM?.length) ? <>
          <h4 className="text-m mb-2 text-gray-600 text-left fw-bold">Multi-Variate Analysis</h4>
          <div ref={chartRefOne} className='mb-4' style={{ backgroundColor: 'white', borderRadius: '5px', paddingBottom: "5px" }}>
            <MultivariateAnalysisChart filterdata={GlobalData} />
          </div>
        </> :
          <div className={`d-flex justify-content-center align-items-center height-400 ${styles["height-300"]}`} >
            Please Select A Vehicle From The Dropdown Menu Above
          </div>
        }
      </div>
    </div>
  );
}

export default MultivariateAnalysisTab;
